import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { API_BASE_URL } from "constants/ApiConstant";
import { LOGIN } from "constants/ApiSlug";
import { USER_DATA } from "constants/DataConstant";
import axios from "axios";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  user: null,
};

export const signIn = createAsyncThunk(
  "admin/login",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;

    try {
      const response = await axios.post(`${API_BASE_URL}${LOGIN}`, {
        email,
        password,
      });

      const resData = response.data;
      console.log(resData);

      // Check if access token is returned
      if (resData?.access_token && resData?.admin) {
        // Store access token and user data in localStorage
        localStorage.setItem(AUTH_TOKEN, resData?.access_token);
        localStorage.setItem(USER_DATA, JSON.stringify(resData?.admin));

        return {
          token: resData?.access_token,
          user: resData?.admin,
        };
      } else {
        return rejectWithValue("Login failed");
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.message || "Login error";
      return rejectWithValue(errorMessage);
    }
  }
);
export const editAdminProfile = createAsyncThunk(
  "admin/editProfile",
  async (data, { rejectWithValue }) => {
    const { name, email } = data;
    try {
      const response = await axios.put(`${API_BASE_URL}admin/update`, {
        name,
        email,
      },{
		headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`
        }
	  });

      const resData = response.data;

      if (resData?.admin) {
		localStorage.removeItem(USER_DATA);
        localStorage.setItem(USER_DATA, JSON.stringify(resData?.admin));
      }
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.message || "Login error";
      return rejectWithValue(errorMessage);
    }
  }
);

export const signOut = createAsyncThunk("auth/signOut", async () => {

  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(USER_DATA);
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
	  .addCase(editAdminProfile.pending, (state) => {
		state.loading = true;
	  })
	  .addCase(editAdminProfile.fulfilled, (state, action) => {
		state.loading = false;
		state.redirect = "/";
	  })
	  .addCase(editAdminProfile.rejected, (state, action) => {
		state.message = action.payload;
		state.showMessage = true;
		state.loading = false;
	  })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
